import { useState } from 'react';
import { AritoFormV2, AritoIcon, BottomActionBarV2, DialogV2 } from '@/components/custom/erp';
import { formSchema, initialValues, type FormValues } from '../schemas';
import type { DiaChi, DiaChiInput, KhachHang } from '@/types/schemas';
import { FormMode } from '@/types/form';
import BasicForm from './BasicForm';

interface FormDialogProps {
  mode: FormMode;
  open: boolean;
  onClose: () => void;
  onSubmit?: (data: DiaChiInput) => void;
  onAddButtonClick?: () => void;
  onEditButtonClick?: () => void;
  onDeleteButtonClick?: () => void;
  onCopyButtonClick?: () => void;
  onWatchButtonClick?: () => void;

  initialData?: DiaChi | null;
}
function FormDialog({
  mode,
  open,
  onClose,
  onAddButtonClick,
  onCopyButtonClick,
  onDeleteButtonClick,
  onEditButtonClick,
  initialData,
  onSubmit
}: FormDialogProps) {
  const [khachHang, setKhachHang] = useState<KhachHang | string | null>(
    initialData?.ma_kh_data || initialData?.ma_kh || null
  );

  const handleSubmit = async (data: FormValues) => {
    try {
      const formData = {
        ...data,
        ma_kh: (khachHang as KhachHang | null)?.uuid || null
      };
      onSubmit?.(formData as DiaChiInput);
    } catch (err: unknown) {
      console.error('Error submitting form:', err);
    }
  };
  return (
    <>
      <DialogV2
        open={open}
        onClose={onClose}
        title={mode === 'add' ? 'Mới' : mode === 'edit' ? 'Sửa' : 'Xem'}
        maxWidth='lg'
        disableBackdropClose={true}
        disableEscapeKeyDown={true}
        titleIcon={<AritoIcon icon={281} />}
      >
        <AritoFormV2
          mode={mode}
          hasAritoActionBar={false}
          schema={formSchema}
          onSubmit={handleSubmit}
          initialData={(initialData as Partial<FormValues> | null | undefined) || initialValues}
          className='w-full md:min-w-[500px] lg:min-w-[600px]'
          headerFields={
            <BasicForm formMode={mode} customer={khachHang as KhachHang | null} setCustomer={setKhachHang} />
          }
          bottomBar={
            <BottomActionBarV2
              mode={mode}
              onAdd={onAddButtonClick}
              onEdit={onEditButtonClick}
              onDelete={onDeleteButtonClick}
              onCopy={onCopyButtonClick}
              onClose={onClose}
            />
          }
        />
      </DialogV2>
    </>
  );
}

export default FormDialog;
